/**
 * Platform-aware image cache policy for expo-image.
 *
 * `memory-disk` is optimal on native (iOS/Android) but causes issues on web
 * where the Service Worker cache and browser HTTP cache handle persistence.
 * Using `memory` on web avoids stale-cache bugs and CORS preflight issues.
 */
import { Platform } from 'react-native'

export const IMAGE_CACHE_POLICY: 'memory' | 'memory-disk' =
  Platform.OS === 'web' ? 'memory' : 'memory-disk'

/**
 * expo-image crossfade decodes/resizes on the UI thread during Fabric mount
 * (TAGO-MOBILE-46 App Hang in ImageView.processImage → resize). Keep the
 * dissolve on web; native shows the bitmap when it is ready.
 */
export const IMAGE_TRANSITION_MS = Platform.OS === 'web' ? 200 : 0
